<template>
  <div :key="componentKey" class="room flex flex-none" :style="{ minWidth, width: minWidth }">

    <div class="flex flex-row" style="width: 100% !important;">
      <div
        v-for="(v, i) in numBlocks"
        :key="`room-${id}-block-${i}`"
        class="block"
        :style="{ backgroundColor: theme }"
      >

        <TreatmentCard
          v-if="
            occupied
            && !!filteredTreatments[i]
            && !!filteredTreatments[i].treatment
          "
          :id="filteredTreatments[i].uuid"
          :treatment="filteredTreatments[i]"
          :room="room"
          :appointment="appointment"
          :appointment-id="appointment.uuid"
          :disabled="activeTreatmentId && !(filteredTreatments[i].uuid === activeTreatmentId)"
          :initials="$filters.initials(filteredTreatments[i].doctor.name)"
          :initialsColor="filteredTreatments[i].doctor.color"
          :room-id="id"
          :title="filteredTreatments[i].treatment.name"
          :initial-allocated-time="filteredTreatments[i].duration * 1000"
          :started-at="filteredTreatments[i].started_at"
          :ended-at="filteredTreatments[i].ended_at"
        />
        <v-card
            v-if="occupied && (i + 1) === filteredTreatments.length && !!filteredTreatments[i] !== undefined && fitsTheFilter"
            class="gray-tile add-button"
            @click="$store.dispatch(
            'selectAppointment',
            { appointment: { ...appointment, room }
          })"
        >
          +
        </v-card>

      </div>
    </div>

    <div class="block block--final" :style="{ backgroundColor: theme }">
      <TimerCard
        v-if="occupied && showTimer"
        appointment-state="inactive"
        :appointment="appointment"
        :number-of-treatments="appointment.treatments.length"
        :room-id="id"
        :is-disabled="!fitsTheFilter"
        @click="fitsTheFilter ? $store.dispatch('selectAppointment', { appointment }) : null"
      />
    </div>

  </div>
</template>

<script lang="ts">
import TimerCard from '@/components/cards/TimerCard.vue';
import TreatmentCard from '@/components/cards/TreatmentCard.vue';
import { defineComponent } from 'vue';
import { orderBy } from 'lodash-es';

export default defineComponent({
  name: 'Room',
  components: { TimerCard, TreatmentCard },
  props: {
    id: {type: String, required: true},
    room: {type: Object, default: null },
    theme: {type: String, default: '#C9D4E2'},
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      activeTreatmentId: null,
      componentKey: 0,
      // showAppointment: true,
      showTimer: true,
    };
  },
  computed: {
    numBlocks() {
      const minBlocsCount = 4;
      const actualCount = Math.trunc((this.windowWidth - 264) / 112) - 1;
      return actualCount > minBlocsCount ? actualCount : minBlocsCount;
    },
    numBlocksArray() {
      return [...Array(this.numBlocks).keys()];
    },
    minWidth() {
      const px = 112 * (this.numBlocks + 1);
      return `${px - 88}px`;
    },
    occupied() {
      return !!this.appointment && !!this.appointment.uuid;
    },
    filter() {
      return this.$store.state.filter;
    },
    fitsTheFilter() {
      let fitsTheFilter = false;
      this.appointment.treatments.some( (t) => {
        if (t.doctor.uuid === this.filter) {
          fitsTheFilter = true;
          return false;
        }
      });

      return !!this.filter ? fitsTheFilter : true;
    },
    filteredTreatments() {

      const ts = this.appointment.treatments;
      if (!this.filter && this.occupied) { this.showTimer = true; }

      const complete = this.appointment.treatments.filter((t: { status: string; }) => ['completed'].includes(t.status));
      const incomplete = this.appointment
          .treatments.filter((t) => !t.ended_at)
          .filter((t: { status: string; }) => !['paused', 'processing'].includes(t.status));
      const active = this.appointment.treatments.filter( (t: { status: string; }) => ['paused', 'processing'].includes(t.status));
      let sorted = [...active, ...incomplete, ...orderBy(complete, 'ended_at')];

      // because indexing gets messed up when you filter, so if you start a treatment and then filter, then
      // the treatment in the same index will show up as having been started
      sorted = sorted.map((t) => {
        if (ts.includes(t)) {
          return t;
        } else {
          return undefined;
        }
      });

      return sorted;
    },
    appointment() {
      return this.room.appointments.find(({ status: x }) =>
        ['processing', 'paused'].includes(x),
      ) || null;
    },
  },
  created(): void {
    this.$eventBus.on(`room-${this.id}-state`, this.setActiveTreatmentId);
  },
  mounted(): void {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeUnmount(): void {
    this.$eventBus.off(`room-${this.roomId}-state`, this.setActiveTreatmentId);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    setActiveTreatmentId(payload: any) {
      console.log('Setting active Treatment id:', { payload });
      const { state, treatmentId } = payload;
      const activeStates = ['active', 'warning', 'overtime'];
      if (activeStates.includes(state)) {
        this.activeTreatmentId = treatmentId;
      } else {
        this.activeTreatmentId = null;
      }
    },
    // filterAppointment() {
    //   console.log(this.filter);
    //   console.log(this.appointment);

    //   const filtered = (t) => {
    //     if (t.doctor) {
    //       if (t.doctor.uuid === this.filter) {
    //         return true;
    //       }
    //     }
    //     return false;
    //   }

    //   if (this.appointment) {
    //     if (this.filter) {
    //       if (this.appointment.doctor) {
    //         if (this.appointment.doctor.uuid === this.filter) {
    //           this.showAppointment = true;
    //         } else {
    //           this.showAppointment = this.appointment.treatments.find(t => filtered(t)) ? true : false;
    //         }
    //       } else {
    //         this.showAppointment = this.appointment.treatments.find(t => filtered(t)) ? true : false;
    //       }
    //     } else {
    //       this.showAppointment = true;
    //     }
    //   }
    //   console.log(this.showAppointment);
    // }
  },
});
</script>

<style scoped>
.room {
  height: 68px;
}

.block {
  position: relative;
  width: 112px;
  height: 100%;
  flex: none;
  background-color: transparent;
  border-top: 2px solid white;
  border-left: 2px solid white;
  @apply flex justify-center items-center;
}

.block--header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: white;
}

.block--header__text {
  @apply h-6 w-full flex justify-center items-center bg-gray-darker text-xs text-white font-bold;
}

.block--final {
  width: 100px;
  position: sticky;
  right: 0;
  z-index: 5;
}

.add-button {
  position: absolute;
  top: 20px;
  right: -30px;
  display: flex;
  justify-content: center;
  width: 28px;
  height: 26px;
  cursor: pointer;
  z-index: 6;
}
</style>
